var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorldDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WORLD_x5F_DOWN"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "frm_3-341",
    "data-name": "frm_3-34",
    x: 8.0795,
    y: 8.07978,
    width: 43.841,
    height: 43.841,
    rx: 10,
    ry: 10,
    transform: "translate(-12.42661 30.00008) rotate(-45)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "frm_3-351",
    "data-name": "frm_3-35",
    x: 10.01836,
    y: 11.83799,
    width: 39.96329,
    height: 39.96329,
    rx: 10,
    ry: 10,
    transform: "translate(-13.71308 30.53296) rotate(-45)",
    fill: "#f59e00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "World",
    d: "M45.07407,32.39054c-.01596,8.31024-6.74876,15.04304-15.059,15.059-8.23621.01586-14.92583-6.64805-14.94169-14.88426-.00011-.05825.00012-.1165.00069-.17474-.02988-8.22181,6.61099-14.91112,14.8328-14.941.03606-.00013.07213-.00013.1082,0,8.31024.01596,15.04304,6.74876,15.059,15.059,0,0,0-.118,0-.118ZM32.60307,19.09654c-1.44086-.21554-2.90258-.25516-4.353-.118.20734.94459-.00735,1.93264-.588,2.706-.941,1.176-2.706.118-3.412,1.882s-.471,2-1.294,2.941c-.823.941-.588.353-1.412.235-.46818-.06842-.94382-.06842-1.412,0-.235,0-.824.588-1.176.824-.61284.18488-1.24381.30323-1.882.353l-.471,1.647c1.176.588,2,.706,2.353,2.118s0,1.294.588,1.882c1.176,1.176,2.941,2,2.588,4s-1.294,2-1.294,2.353.706.706.588,1.294-.706.824-1.059,1.176c.44108.42622.91303.81929,1.412,1.176.538.43082,1.13169.78703,1.765,1.059.40288-.15021.76539-.39188,1.059-.706.71521-.51072,1.6184-.68215,2.471-.469.86404.05956,1.70592.30009,2.471.706.588.353,1.765,1.882,2,1.882.76287-.05521,1.51473-.21365,2.235-.471,2.56331-.73612,4.85406-2.2087,6.588-4.235,1.647-2,1.529-1.882,1.412-2-.824-.235-1.647-.588-1.765-1.529-.353-1.882,1.882-2.588,3.412-2.588.35295-1.98443.35295-4.01557,0-6-1.647-.118-3.059,1.412-4.588.824,0,1.529-.588,2-2.118,2s-.588-.235-.706,0,.588.824.706.941c.471.353,1.176,0,1.529.706.588,1.294-1.294,2.353-1.647,3.529s.235,2.235-.706,3.412-4.235,3.647-5.059,1.294,0-.824-.235-1.059l-.353-.353c-.706-1.176-.353-2.471-.471-3.647s-1.529-.941-2.588-.941c-2-.118-4-1.647-3.647-3.882s4.941-3.294,6.706-3.176,1.412.471,2.353.353,1.412-.471.824-1.176-3.412-.824-4.588-1.176c-1.765-.588-.235-1.412.235-2.235s0-1.412.824-1.647,2.353-.235,2.471-.588c-.0214-.40126-.10055-.79733-.235-1.176.00237-.72044.12158-1.43573.353-2.118,0,0,.116-.003.116-.00299Z",
    fill: "#82368c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorldDownIcon);
export default __webpack_public_path__ + "static/media/WorldDownIcon.3812527d48c9dd216de6363eeefde27c.svg";
export { ForwardRef as ReactComponent };